<template>
  <svg
    width="20"
    height="20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  ><path
    d="M19.375 12.5v2.917a1.25 1.25 0 0 1-1.25 1.25H1.875a1.25 1.25 0 0 1-1.25-1.25V12.5a2.5 2.5 0 1 0 0-5V4.583a1.25 1.25 0 0 1 1.25-1.25h16.25a1.25 1.25 0 0 1 1.25 1.25V7.5a2.5 2.5 0 0 0 0 5Z"
    stroke="currentColor"
    stroke-width="1.25"
    stroke-linecap="round"
    stroke-linejoin="round"
  /><path
    d="M6.042 7.5a1.25 1.25 0 1 0 2.5 0 1.25 1.25 0 0 0-2.5 0ZM12.084 12.5a1.25 1.25 0 1 0 2.5 0 1.25 1.25 0 0 0-2.5 0ZM13.125 6.875l-6.25 6.25"
    stroke="currentColor"
    stroke-width="1.25"
    stroke-linecap="round"
    stroke-linejoin="round"
  /></svg>
</template>
